import {Component, ChangeDetectionStrategy} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-logout',
  imports: [
    NgOptimizedImage,
  ],
  templateUrl: './logout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logout.component.css'
})
export class LogoutComponent {

}
